import { FC, useRef, useState } from 'react';
import cn from 'classnames';

import { ITable } from '@/types/types';
import Arrow from '@/public/icons/arrow-navLink.svg';
import { useTableHeadersHook } from '@/hooks';
import { AnimatedComponent } from '@/components/common/AnimatedComponent';
import { useLocaleHook } from '@/hooks';
interface ITableProps {
  data: ITable[];
  className?: string;
}

export const TableMobile: FC<ITableProps> = ({ data, className }) => {
  const columns = useTableHeadersHook();

  const [droppedItemIndex, setDroppedItemIndex] = useState<number>(-1);
  const listRef = useRef<HTMLUListElement>(null);
  const locale = useLocaleHook();
  const isUk = locale === 'uk';

  const handleClick = (index: number) => {
    if (droppedItemIndex == index) {
      setDroppedItemIndex(-1);
    } else {
      setDroppedItemIndex(index);
      if (listRef.current) {
        listRef.current
          .querySelector(`#item-${index}`)
          ?.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <>
      {data && (
        <ul className={cn('grid grid-cols-1 gap-5', className)} ref={listRef}>
          {data.map((item, index) => (
            <li
              key={item.name + item.form + item.certificate}
              className="relative"
            >
              <button
                className="flex w-full items-center justify-between rounded bg-accentMain px-5 py-2.5 text-white dark:bg-accentAdditional dark:text-darkFullDark"
                onClick={() => handleClick(index)}
                aria-label={
                  droppedItemIndex != index
                    ? isUk
                      ? `Розгорнути інформацію про ${item.name}`
                      : `Expand information about ${item.name}`
                    : isUk
                    ? `Згорнути інформацію про ${item.name}`
                    : `Collapse information about ${item.name}`
                }
              >
                <div className="text-start">
                  <dt className="mb-2 text-lg">{item.name}</dt>
                  <dd className="text-md leading-4">{item.form}</dd>
                </div>
                <Arrow
                  className={cn('h-6 w-6 text-inherit', {
                    'rotate-180 transform': droppedItemIndex == index,
                  })}
                />
              </button>
              <AnimatedComponent
                className={cn(
                  'grid origin-top grid-cols-1 gap-5 rounded bg-disabledBg p-5 dark:bg-darkFullDark',
                  {
                    hidden: droppedItemIndex != index,
                    'block scale-y-0': droppedItemIndex == index,
                  },
                )}
                variants={{
                  visible:
                    droppedItemIndex == index
                      ? { opacity: 1, scaleY: 1 }
                      : { opacity: 0, scaleY: 0 },
                }}
              >
                {columns.map(column => (
                  <div className=" text-base" key={item.name + column.accessor}>
                    <dt className="dark:dark:gray-scale-red-diff mb-2 text-lg text-accentMain">
                      {column.Header}
                    </dt>
                    <dd className="text-md leading-4">
                      {item[column.accessor]}
                    </dd>
                  </div>
                ))}
              </AnimatedComponent>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
